import './accessioningScreen.scss'
import React, {useCallback, useEffect, useRef, useState} from 'react';
import InputComponent from "../../shared/components/core/input/InputComponent";
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';
import TooltipComponent from "../../shared/components/tooltip/tooltipComponent";
import AccessioningSampleCard from "../../shared/components/accessioning-sample-card/accessioningSampleCard";
import {CommonService} from "../../shared/services";
import {IAPIResponseType} from "../../shared/models/api.model";
import StatusCardComponent from "../../shared/components/status-card/statusCardComponent";
import {APIConfig, ImageConfig} from "../../constants";
import {useDispatch} from "react-redux";
import {setCurrentNavParams, setSideMenuView} from "../../store/actions/header.action";
import LottieFileGenarationComponent
    from "../../shared/components/core/lottie-file-genaration/LottieFileGenarationComponent";
import {AXIOS_REQUEST_CANCELLED} from "../../shared/services/api.service";


interface AccessioningScreenProps {

}


const AccessioningScreen = (props: AccessioningScreenProps) => {

        const [scanOrEnterBarcode, setScanOrEnterBarcode] = useState<string>("");
        const [accessioningSampleList, setAccessioningSampleList] = useState<any>(undefined);
        const [pendingAccessioningSampleList, setPendingAccessioningSampleList] = useState<any>(undefined);
        const [accessionedSampleList, setAccessionedSampleList] = useState<any>(undefined);
        const [isAccessioningSampleListLoading, setIsAccessioningSampleListLoading] = useState<boolean>(false);
        const [isAccessioningSampleListLoaded, setIsAccessioningSampleListLoaded] = useState<boolean>(false);
        const [isAccessioningSampleListLoadingFailed, setIsAccessioningSampleListLoadingFailed] = useState<boolean>(false);
        const APICallSubscription = useRef<any>(null);

        const dispatch = useDispatch();

        useEffect(() => {
            dispatch(setCurrentNavParams("Accessioning", "Accessioning"));
            dispatch(setSideMenuView('default'));
        }, [dispatch]);

        const getAccessioningSample = useCallback(() => {
            const cancelTokenSource = CommonService.getCancelToken();
            const payload = {
                barcode: scanOrEnterBarcode,
            };
            let apiCall;
            apiCall = CommonService._api.post;
            if (APICallSubscription && APICallSubscription.current) {
                APICallSubscription.current.cancel();
            }
            APICallSubscription.current = cancelTokenSource;
            let accessioningSampleList: any = [];
            let pendingAccessioningSampleList: any = [];
            let accessionedSampleList: any = [];

            setIsAccessioningSampleListLoading(true);
            setIsAccessioningSampleListLoaded(false);
            setIsAccessioningSampleListLoadingFailed(false);

            apiCall(APIConfig.GET_ACCESSION_SAMPLES.URL, payload, {}, {cancelToken: cancelTokenSource.token}).then((response: IAPIResponseType<any>) => {
                if (response.data) {
                    accessioningSampleList = response.data;
                }
                pendingAccessioningSampleList = accessioningSampleList.filter((sample: any) => sample.status === 'pending' || sample.status === 'Ready For Collection');
                accessionedSampleList = accessioningSampleList.filter((sample: any) => sample.status === 'accessioned');
                setAccessioningSampleList(accessioningSampleList);
                setPendingAccessioningSampleList(pendingAccessioningSampleList)
                setAccessionedSampleList(accessionedSampleList)
                setIsAccessioningSampleListLoading(false);
                setIsAccessioningSampleListLoaded(true);
                setIsAccessioningSampleListLoadingFailed(false);
            }).catch((error) => {
                if (error.reason !== AXIOS_REQUEST_CANCELLED) { // if previous request got cancelled do not close loading state
                    setAccessioningSampleList(accessioningSampleList);
                    setPendingAccessioningSampleList(pendingAccessioningSampleList)
                    setAccessionedSampleList(accessionedSampleList)
                    setIsAccessioningSampleListLoading(false);
                    setIsAccessioningSampleListLoaded(false);
                    setIsAccessioningSampleListLoadingFailed(true);
                }
            })
            //eslint-disable-next-line react-hooks/exhaustive-deps
        }, [scanOrEnterBarcode]);

        // const getAccessioningSampleList = useCallback(() => {
        //     const payload = {
        //         barcode: scanOrEnterBarcode,
        //     };
        //     let accessioningSampleList: any = [];
        //     let pendingAccessioningSampleList: any = [];
        //     let accessionedSampleList: any = [];
        //
        //     setIsAccessioningSampleListLoading(true);
        //     setIsAccessioningSampleListLoaded(false);
        //     setIsAccessioningSampleListLoadingFailed(false);
        //     CommonService._accessioning.getAccessionSamples(payload)
        //         .then((response: IAPIResponseType<any>) => {
        //             if (response?.data) {
        //                 accessioningSampleList = response.data;
        //             }
        //             pendingAccessioningSampleList = accessioningSampleList.filter((sample: any) => sample.status === 'pending');
        //             accessionedSampleList = accessioningSampleList.filter((sample: any) => sample.status === 'accessioned');
        //
        //             setAccessioningSampleList(accessioningSampleList);
        //             setPendingAccessioningSampleList(pendingAccessioningSampleList)
        //             setAccessionedSampleList(accessionedSampleList)
        //             setIsAccessioningSampleListLoading(false);
        //             setIsAccessioningSampleListLoaded(true);
        //             setIsAccessioningSampleListLoadingFailed(false);
        //         })
        //         .catch((error: any) => {
        //             setAccessioningSampleList(accessioningSampleList);
        //             setPendingAccessioningSampleList(pendingAccessioningSampleList)
        //             setAccessionedSampleList(accessionedSampleList)
        //             setIsAccessioningSampleListLoading(false);
        //             setIsAccessioningSampleListLoaded(false);
        //             setIsAccessioningSampleListLoadingFailed(true);
        //         });
        // }, [scanOrEnterBarcode]);

        useEffect(() => {
            if (scanOrEnterBarcode) {
                getAccessioningSample();
            }
        }, [getAccessioningSample, scanOrEnterBarcode])


        return (
            <div className="accessioning-list-screen screen t-form-screen">
                <div className="scan-enter-input-wrapper">
                    <InputComponent type={"text"}
                                    label={"Scan/Enter Barcode"}
                                    placeholder={"Scan/Enter Barcode"}
                                    size={"small"}
                                    name={"Enter Barcode"}
                                    id="scan-enter-barcode"
                                    value={scanOrEnterBarcode}
                                    onChange={(value: string) => setScanOrEnterBarcode(value)}
                    />
                    <TooltipComponent
                        tooltip={"Please manually type or scan a barcode (with a scanner) to accession the appropriate sample."}
                        arrow={true}>
                        <span className="pdd-left-15"><InfoOutlinedIcon/></span>
                    </TooltipComponent>
                </div>
                <div className="mrg-top-30">
                    {
                        isAccessioningSampleListLoading && <div className="h-v-center">
                            <LottieFileGenarationComponent
                                loop={true}
                                autoplay={true}
                                animationData={ImageConfig.LoadingLottieFile}/>
                        </div>
                    }
                    {
                        isAccessioningSampleListLoadingFailed && <div className="bg-color-white">
                            <StatusCardComponent title={"Accessioning samples failed to load"}/>
                        </div>
                    }
                    {isAccessioningSampleListLoaded && <>
                        {accessioningSampleList?.length > 0 ?
                            <>
                                {pendingAccessioningSampleList.length > 0 && <div className="pending-sample-list-body">
                                    <div className="sample-list-title">Pending Samples</div>
                                    {
                                        pendingAccessioningSampleList?.map((sample: any) => {
                                            return (<div className="sample-list-wrapper" key={CommonService.getUUID()}>
                                                    <AccessioningSampleCard
                                                        sampleDetails={sample}
                                                        getAccessioningSample={getAccessioningSample}
                                                        status={sample.status}/>
                                                </div>
                                            )
                                        })
                                    }
                                </div>}
                                {accessionedSampleList.length > 0 &&
                                    <div className="accessioned-sample-list-body pdd-top-20">
                                        <div className="sample-list-title">Accessioned Samples</div>
                                        {
                                            accessionedSampleList?.map((sample: any) => {
                                                return (
                                                    <div key={CommonService.getUUID()}>
                                                        <AccessioningSampleCard sampleDetails={sample}
                                                                                status={'accessioned'}/>
                                                    </div>
                                                )
                                            })
                                        }
                                    </div>}
                            </> :
                            <div className=" no-data-card-with-gif animated-gif-wrapper">
                                <img src={ImageConfig.NoDataGif} alt={"no data found"}/>
                                <div className="table-no-data-found">No data to show</div>
                            </div>
                        }
                    </>
                    }
                </div>
            </div>
        )
    }

;

export default AccessioningScreen;
